import type { IssueDetailV2InitProps } from "../src/issue_detail_v2/types/init";

type Main = typeof import("../src/issue_detail_v2/main");
let mainLoading: Promise<Main> | undefined;

// init and destroy chain on one import promise, so a destroy issued before the chunk loads still runs
// after its init. A failed import is dropped so the next init retries it.
const loadMain = (): Promise<Main> =>
  (mainLoading ||= import("../src/issue_detail_v2/main").catch((error: unknown) => {
    mainLoading = undefined;
    throw error;
  }));

window.EasyIssueDetailV2 ||= {};

window.EasyIssueDetailV2.init = (appWrapperId: string, props: IssueDetailV2InitProps): Promise<void> =>
  loadMain().then(main => main.init(appWrapperId, props));

// Nothing to destroy before the first init. init already reports a failed import, so only that rejection
// is ignored here.
window.EasyIssueDetailV2.destroy = (appWrapperId: string): void => {
  void mainLoading?.then(
    main => main.destroy(appWrapperId),
    () => undefined
  );
};
